// Filename - pages/contact.js

import React from "react";
import MyHeader from "../components/headerComponent.js";
import Navbar from "../components/nav.js";
import ContactForm from "../components/contactForm.js";
import SocialsBar from "../components/socialsBar.js";
import MyFooter from "../components/footerComponent.js";

const ContactUs = () => {
	return (
		<div className="About-Us">
            <header>
                <MyHeader />
                <Navbar />
            </header>
            <main>
                <h2> Contact Us </h2>
                <ContactForm />
            </main>
            <footer>
                <SocialsBar />
                <MyFooter />
            </footer>
		</div>
	);
};

export default ContactUs;
